module.exports = __webpack_public_path__ + "img/banner03.7aeb93ca.png";